import { createSelector } from "reselect";

const mapSettings = (state) => state.clientConfig?.mapSettings;

export const maxBoundsSelector = createSelector(mapSettings, (mapSettings) => {
    const maxBounds = mapSettings?.maxBounds;

    // maxBounds should have 2 coordintes([[South West], [North East]]).
    // Ensure maxBounds have valid coordinates: [[lng1, lat1], [lng2, lat2]].
    // Longitude should be between -180 and 180, Latitude should be between -90 and 90.
    const validBounds =
        maxBounds &&
        maxBounds.length === 2 &&
        maxBounds.every(coord => Array.isArray(coord) && coord.length === 2 && coord[0] >= -180 && coord[0] <= 180 && coord[1] >= -90 && coord[1] <= 90);

    // If invalid, return null to disable maxBounds.
    return validBounds ? maxBounds : null;
});
